import { render, staticRenderFns } from "./CeremonySearch.vue?vue&type=template&id=a8bec8a0&scoped=true"
import script from "./CeremonySearch.vue?vue&type=script&lang=js"
export * from "./CeremonySearch.vue?vue&type=script&lang=js"
import style0 from "./CeremonySearch.vue?vue&type=style&index=0&id=a8bec8a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bec8a0",
  null
  
)

export default component.exports